// @flow
import React from 'react';

import { ESTIMATE_ACCOUNT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-account-details';
import { SFDC_ACCOUNT_NAME_BACKEND_NAME } from '../../constants';
import { TextField } from '../../formik-utils/FormFields';

export const EstimateAccountNameContainer = ({ disableOnFormErrors }) => {
  const estimateAccountNameConfig = ESTIMATE_ACCOUNT_DETAILS_CONFIG_MAP.get(
    SFDC_ACCOUNT_NAME_BACKEND_NAME
  );
  return (
    <TextField
      disableOnFormErrors={disableOnFormErrors}
      fieldDisplayName={estimateAccountNameConfig.displayName}
      fieldName={estimateAccountNameConfig.backendFieldName}
      icon={estimateAccountNameConfig.icon}
    />
  );
};
